import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReportingDashboardComponent } from '@flyfreely/user-reporting-dashboard';

@Component({
    selector: 'report-view',
    templateUrl: './report-view.component.html',
    styleUrls: ['./report-view.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReportingDashboardComponent
    ],
    providers: []
})
export class ReportViewComponent {}